import { Tune } from "@mui/icons-material";
const Sorting = () => {
  const sorts = [
    {
      type: "Regions",
      data: ["In your country", "world wide"],
    },
    {
      type: "Type",
      data: ["Pharmacy", "Health center", "Hospital", "Clinic"],
    },
    {
      type: "Pick up",
      data: ["Popular", "Trending", "Latest"],
    },
  ];
  const meta = [
    {
      type: "Regions",
      data: [
        { name: "In your country", totalData: 10 },
        { name: "world wide", totalData: 10 },
      ],
    },
    {
      type: "Type",
      data: [
        { name: "Pharmacy", totalData: 5 },
        { name: "Health center", totalData: 24 },
        { name: "Hospital", totalData: 20 },
        { name: "Clinic", totalData: 10 },
      ],
    },
    {
      type: "Pick up",
      data: [
        { name: "Popular", totalData: 20 },
        { name: "Trending", totalData: 30 },
        { name: "Latest", totalData: 0 },
      ],
    },
  ];

  return (
    <div className="flex min-w-[24rem] flex-col gap-3">
      <div className="flex w-full justify-between">
        <div className="flex text-[#1A22C5] items-center">
          <Tune />
          <div className=" font-semibold text-xl">Filter by</div>
        </div>
        <div className="flex gap-2 text-sm items-center">
          <div>Showing</div>
          <div className="text-[#0A307B] font-semibold">
            All Health Services
          </div>
        </div>
      </div>
      <form
        style={{ boxShadow: " 0px 0px 3px rgba(0, 0, 0, 0.25)" }}
        className="p-5 rounded-lg flex flex-col gap-5"
      >
        {sorts.map((sort, index) => (
          <div key={index} className="flex flex-col gap-3">
            <div className="text-[#1A22C5] text-xl font-bold">{sort.type}</div>
            <div className="flex flex-col gap-3">
              {sort.data.map((data, index) => (
                <label
                  key={index}
                  className="cursor-pointer flex items-center gap-2"
                >
                  <input type="checkbox" name={data} />
                  <span>{data}</span>
                  <span className="text-xs text-[#1A22C5]">
                    &#40;
                    {
                      meta
                        .find((value) => value.type === sort.type)
                        .data.find((value) => value.name === data).totalData
                    }
                    &#41;
                  </span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </form>
    </div>
  );
};
export default Sorting;
